import { Outlet, Navigate } from "react-router-dom";
import { useStyle } from "../context/styleContext/styleContext";
import {useContext, useState, useEffect} from "react";
import {UserContext} from '../context/userContext/userContext';
import {useNavigate} from 'react-router-dom'
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';


const AdminRoutes = () => {

  const{user, isLoading} = useContext(UserContext);
  const navigate = useNavigate()

  const [height, setHeight] = useState(window.innerHeight)
  const [width, setWidth] = useState(window.setWidth)

  const { style, setStyle } = useStyle();

  useEffect(() => {

    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

  if(isLoading) {

    return (
      <>
      <div style={{ textAlign:'center', minHeight:height - 180, alignContent:'center'}}>
      <CircularProgress sx={{color:style.color1}} size='10em' />
      <h1>Loading...</h1>

      </div>
      
    </>

    )
  }
  else{   

    if(!user)
    {    
      //navigate to login page
      return <Navigate to="/login" />;
    }
    if(!user.isAdmin)
      {    
        //navigate to login page
        return <Navigate to="/" />;
      }
    else{
      return(<Outlet />)
    }

}

};

export default AdminRoutes;